import React, { useEffect } from 'react';

import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { IdentityPoolService } from '~src/authentication/services/IdentityPoolService';
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { AddUsersButton, AddUsersButtonActionProps } from '~src/userManagement/components/AddUsersButton';

import { AddUsersFromIdentityPoolButton } from './AddUsersFromIdentityPoolButton';


const POOL_REFRESH_RATE_SECONDS = 5 * 60; // Every 5 minutes

export function AddUsersButtonStrategy(props: Omit<AddUsersButtonActionProps, 'identityStoreType'>) {

  const [identityPools, setIdentityPools] = React.useState([] as IIdentityPool[]);
  const [areIdentityPoolsPopulated, setAreIdentityPoolsPopulated] = React.useState(false);

  function refreshPools() {
    IdentityPoolService.tryFetchActiveIdentityPools().then((result: IIdentityPool[]) => {
      setIdentityPools(result);
    }).finally(() => {
      setAreIdentityPoolsPopulated(true);
    });
  }

  useEffect(() => {
    refreshPools();
    const timer = setTimeout(refreshPools, POOL_REFRESH_RATE_SECONDS * 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!areIdentityPoolsPopulated) {
    return null; // Don't render while we are loading.
  } else if (identityPools.length > 0) {
    // Show the new buttons to add Users in Identity Pools or Add Identities. 
    return <AddUsersFromIdentityPoolButton {...props} identityPools={identityPools} />;
  } else {
    // If there are no pools, show the standard add users button same way as we did before.
    return <AddUsersButton {...props} identityStoreType={ServerSettingsUnauthenticated.domainFamily()} />;
  }
}
